import React, { useEffect } from 'react';
import api from "../../../../services/api";
import {
    Label, FormGroup, Button, Modal, Container, Row, Col, Alert, Input
 } from "reactstrap"; 
import Loader from "../../../loaders";
import fileDownload from "js-file-download";
import _ from "lodash";
import { FileDropzone } from '../../../FileDropzone';

export default function Editor(props) {
    const {
        item,
        title,
        onSaved,
        onClose
    } = props;

    const [ loading, setLoading ] = React.useState(false);
    const [ itemInEdit, setItemInEdit ] = React.useState(item ?? {});
    const [ validationAlert, setValidationAlert ] = React.useState([]);

    const apiurl = "milestonedocument";

    const handleTextChanged = ({ target: { name, value } }) => {
        setItemInEdit({ ...itemInEdit, [name]: value });
    }

    const downloadAttachment = (fileInfo) => {
        if (fileInfo instanceof File) {
            fileDownload(fileInfo, fileInfo.name);
        } else {
            setLoading(true);
            let url = `${apiurl}/${fileInfo.milestoneDocumentId}/download`;
            api.get(url, { responseType: 'blob' })
            .then(blob => {
                fileDownload(blob.data, fileInfo.filename);
            }).catch(error => {
                console.error(error)
            }).finally(() => setLoading(false))
        }
    }

    const validate = React.useCallback(() => {
        let errors = [ ...validationAlert ];
        const fileExists = _.some(errors, (item) => item.key === "file" && item.type === "required");

        const hasFile = (!!itemInEdit.file || (!itemInEdit.file && !!itemInEdit.filename));
        if (!hasFile && !fileExists)
        {
            errors.push( { key: "file", type: "required", message:  "A File is required" } )
        } else if (hasFile && fileExists)
        {
            _.remove(errors, (item) => item.key === "file" && item.type === "required");
        }

        setValidationAlert([ ...errors ]);
        if (errors.length > 0) {
            return false;
        }
        return true;
    }, [itemInEdit, validationAlert]);

    const files = React.useMemo(() => {
        let name, size, file;

        if (itemInEdit.file) {
            name = itemInEdit.file.name;
            size = itemInEdit.file.size;
            file = itemInEdit.file;
        } else if (itemInEdit.filename) {
            name = itemInEdit.filename;
            size = itemInEdit.fileSizeInKbytes;
            file = itemInEdit;
        } else {
            return null;
        }
        return <aside className="dropzone-list pt-3">
            <Label>Files</Label>
            <ul>
                <li key={name} className="pt-1">
                    <a onClick={() => downloadAttachment(file)}>{name} - {size} bytes</a>
                </li> 
            </ul>
        </aside>
    }, [ itemInEdit.file ]);

    React.useEffect(() => {
        if (itemInEdit && validationAlert.length > 0) validate();
    }, [itemInEdit]);

    const handleSave = (item) => {
        if (!validate())
            return;

        setLoading(true);

        const url = `${process.env.REACT_APP_WEB_API_BASE_URI}/${apiurl}${item.milestoneDocumentId ? `/${item.milestoneDocumentId}` : ""}`;
        const method = item.milestoneDocumentId ? "PUT" : "POST";
        const formData = new FormData();
        formData.append("projectId", item.projectId ?? 0);
        formData.append("milestoneDocumentId", item.milestoneDocumentId ?? 0);
        formData.append("templateName", item.templateName);

        if (item.file) {
            formData.append("file", item.file);
        }

        api({ url, method, data: formData }).then((response) => {
            setLoading(false);
            onSaved();
        })
        .catch((error) => {
            setLoading(false);
            console.error(error);
        });
    }

    return (
        <Modal
            isOpen={true}
            className="modal-lg"
            modalClassName="db-example-modal-lg"
        >
            <div
                className="modal-header"
            >
                <h5
                    className="modal-title"
                >
                    {title ?? `Interview Template - ${itemInEdit?.milestoneDocumentId ? "Edit" : "New"}`}
                </h5>
                <button
                    aria-label="Close"
                    className="close"
                    onClick={onClose}
                    type="button"
                >
                    <span aria-hidden={true}><i className="fas fa-times" /></span>
                </button>
            </div>
            <div
                className="modal-body"
            >
                {validationAlert && validationAlert.length > 0 && <Alert color="warning" className="pa-0 d-flex justify-content-between">
                    <span className="alert-text">
                        <ul className="mb-0">
                        {
                            validationAlert.map((item, index) => <li key={index}>{item.message}</li>)
                        }
                        </ul>
                    </span>
                </Alert>}
                <Container>
                    {(loading) && <Loader />}
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>
                                    Name
                                </Label>
                                <Input
                                    name="templateName"
                                    id="templateName"
                                    type="text"
                                    required
                                    value={itemInEdit.templateName}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <FileDropzone
                            files={files}
                            onDrop={([file]) => {
                                setItemInEdit({ ...itemInEdit, file });
                            }}
                            maxFiles={1}
                        />
                    </Row>
                </Container>
            </div>
            <div
                className="modal-footer"
            >
                <Button
                    color="secondary"
                    onClick={() => {
                        props.onClose();
                    }}
                    type="button"
                >
                    Close
                </Button>
                <Button
                    color="info"
                    onClick={() => handleSave(itemInEdit)}
                    type="button"
                >
                    Save Changes
                </Button>
            </div>
        </Modal>
    )
}